import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { pnlCalculatorModel } from './pnlCalculator.model';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { ServiceStock } from '../../../service-stock.service';
import { HttpResponse } from '@angular/common/http';
import { InvestoridComponent } from '../../../gotx/components/Investorid/Investorid.component';
import { ExchangeComponent } from '../../../gotx/components/Exchange/Exchange.component';
import { ProductComponent } from '../../../gotx/components/Product/Product.component';
import { GotxGridComponent } from '../../../gotx/components/gotx-grid/gotx-grid.component';
import { StockComponent } from 'src/app/gotx/components/Stock/Stock.component';
import { TextBoxComponent } from '../../../text-box/text-box.component';
const customCss: string = `
    .jqx-grid-cell-selected, .jqx-grid-cell-selected-light, .jqx-grid-cell-selected-dark {
        background-color: transparent !important;
        color: inherit !important;
        border-color: transparent !important;
    }
    .jqx-grid-cell-hover, .jqx-grid-cell-hover-light, .jqx-grid-cell-hover-dark {
        background-color: transparent !important;
        color: inherit !important;
    }
    /* Override global .jqx-grid-cell input rule for edit inputs */
    .jqx-grid-cell .pnl-edit-input {
        margin: 2px !important;
        height: calc(100% - 4px) !important;
        width: calc(100% - 4px) !important;
        border: 1px solid #555 !important;
        box-sizing: border-box !important;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        position: relative !important;
        z-index: 10 !important;
    }
    /* Light theme - white background, black text */
    .jqx-widget-light .jqx-grid-cell .pnl-edit-input,
    .jqx-grid-light .jqx-grid-cell .pnl-edit-input,
    .jqx-grid-cell-light .pnl-edit-input {
        background-color: #fff !important;
        color: #000 !important;
    }
    /* Dark theme - transparent background, white text */
    .jqx-widget-dark .jqx-grid-cell .pnl-edit-input,
    .jqx-grid-dark .jqx-grid-cell .pnl-edit-input,
    .jqx-grid-cell-dark .pnl-edit-input,
    [data-theme="dark"] .jqx-grid-cell .pnl-edit-input {
        background-color: var(--transparent-dark) !important;
        color: #fff !important;
    }
`;

@Component({
  selector: 'app-pnlCalculator',
  templateUrl: './pnlCalculator.component.html'
})
export class pnlCalculatorComponent extends FormComponent implements OnInit, AfterViewInit {
  @ViewChild('FieldId_1', { static: false }) FieldId_1: ElementRef;
  @ViewChild('cstmInvestorId', { static: false }) cstmInvestorId: InvestoridComponent;
  @ViewChild('cstmExchange', { static: false }) cstmExchange: ExchangeComponent;
  @ViewChild('cstmProduct', { static: false }) cstmProduct: ProductComponent;
  @ViewChild('cmbStock', { static: false }) cmbStock: StockComponent;
  @ViewChild('spnPurchaseQty', { static: false }) spnPurchaseQty: TextBoxComponent;
  @ViewChild('spnAvgPurchasePrice', { static: false }) spnAvgPurchasePrice: TextBoxComponent;
  @ViewChild('btnAddSymbol', { static: false }) btnAddSymbol: ButtonComponent;
  @ViewChild('btnRefresh', { static: false }) btnRefresh: ButtonComponent;
  @ViewChild('gotxGridComp', { static: false }) gotxGridComp: GotxGridComponent;

  skeletonContentLoaded = false;
  gridData: any[] = [];
  editingRowIndex: number = -1;

  addTotalsRowToGrid() {
    // Calculate totals from gridData (excluding any existing totals row)
    let dataRows = this.gridData.filter(row => row.symbol !== 'TOTAL_ROW');
    
    let totalPurchaseValue = 0;
    let totalLTPTotalValue = 0;
    let totalProfitLoss = 0;
    
    dataRows.forEach(row => {
      totalPurchaseValue += parseFloat(row.purchaseValue || 0);
      totalLTPTotalValue += parseFloat(row.ltpTotalValue || 0);
      totalProfitLoss += parseFloat(row.profitLoss || 0);
    });
    
    // Remove existing totals row if any
    this.gridData = this.gridData.filter(row => row.symbol !== 'TOTAL_ROW');
    
    // Add totals row
    let totalsRow = {
      symbol: 'TOTAL_ROW',
      symbolLabel: 'Total',
      qty: null,
      avgPrice: null,
      purchaseValue: totalPurchaseValue.toFixed(2),
      ltp: null,
      ltpTotalValue: totalLTPTotalValue.toFixed(2),
      profitLoss: totalProfitLoss.toFixed(2),
      isEditing: false
    };
    
    this.gridData.push(totalsRow);
  }

  selectedStock: any;
  showRefreshStatus: boolean = false;

  async revalidate(): Promise<number> {
    var totalErrors = 0;
    super.beforeRevalidate();
    await Promise.all([
      this.cstmInvestorId.revalidate(),
      this.revalidateBasicField('spnPurchaseQty'),
      this.revalidateBasicField('spnAvgPurchasePrice'),
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    this.errors = totalErrors;
    super.afterRevalidate();
    return totalErrors;
  }

  constructor(services: ServiceStock) {
    super(services);
    this.value = new pnlCalculatorModel();
    this.componentCode = 'pnlCalculator';
    this.displayBorder = false;
  }

  setReadOnly(readOnly) {
    super.setBasicFieldsReadOnly(readOnly);
    this.cstmInvestorId.setReadOnly(readOnly);
  }

  async callStockPnlApi(action: string, data: any = {}) {
    let inputMap = new Map();
    // Common fields
    inputMap.set('Body.clientid', this.cstmInvestorId.cmbInvestorId.getFieldValue());
    inputMap.set('Body.action', action);

    // Specific fields based on action or data availability
    if (data.stockSymbol) inputMap.set('Body.symbol', data.stockSymbol);
    if (data.quantity) inputMap.set('Body.quantity', data.quantity);
    if (data.price) inputMap.set('Body.avgPurchasePrice', data.price);

    return new Promise((resolve, reject) => {
      this.services.http.fetchApi('/market/stockpnlCal', 'POST', inputMap).subscribe(
        async (httpResponse: HttpResponse<any>) => {
          var res = httpResponse.body;
          var respCode: any = res['respCode'];
          if (respCode != null && respCode == 0) {
            var resp = res['response'];

            // For View action, reload the grid with response
            if (action === 'view') {
              this.gridData = (resp || []).map(item => {
                let id = this.resolveSymbolId(item.symbol);
                return {
                  ...item,
                  symbolLabel: item.symbolLabel || item.symbol, // Use provided label or current symbol name
                  symbol: id, // Ensure unique ID is in symbol field for subsequent actions
                  isEditing: false
                };
              });
              // Add totals row
              this.addTotalsRowToGrid();
              // Update data property for grid binding
              this.data = [...this.gridData];
              // Reload grid if component is available
              if (this.gotxGridComp && this.gotxGridComp.gotxGrid) {
                setTimeout(() => {
                  this.gotxGridComp.reloadGrid(this.data);
                }, 100);
              }
            }
            // For Insert action
            else if (action === 'insert') {
              // Clear inputs first
              this.cmbStock.gotxInput.val("");
              this.spnPurchaseQty.setValue("");
              this.spnAvgPurchasePrice.setValue("");
              this.selectedStock = undefined;
              
              // After successful insert, call view action to get all data from backend
              // This ensures LTP, LTP Total Value, and Profit/Loss are populated from Java response
              await this.callStockPnlApi('view');
              // Totals row will be added in view action
            }
            // For Delete action
            else if (action === 'delete') {
              if (resp && resp.length > 0) {
                this.gridData = resp.map(item => {
                  let id = this.resolveSymbolId(item.symbol);
                  return {
                    ...item,
                    symbolLabel: item.symbolLabel || this.resolveSymbolLabel(id),
                    symbol: id,
                    isEditing: false
                  };
                });
              } else {
                if (data.rowIdx !== undefined) {
                  this.gridData.splice(data.rowIdx, 1);
                }
              }
              // Add totals row
              this.addTotalsRowToGrid();
              // Update data property for grid binding
              this.data = [...this.gridData];
              // Reload grid if component is available
              if (this.gotxGridComp && this.gotxGridComp.gotxGrid) {
                setTimeout(() => {
                  this.gotxGridComp.reloadGrid(this.data);
                }, 100);
              }
              if (this.editingRowIndex === data.rowIdx) {
                this.editingRowIndex = -1;
              } else if (this.editingRowIndex > data.rowIdx) {
                this.editingRowIndex--;
              }
            }
            // For Update action
            else if (action === 'update') {
              if (resp && resp.length > 0) {
                this.gridData = resp.map(item => {
                  let id = this.resolveSymbolId(item.symbol);
                  return {
                    ...item,
                    symbolLabel: item.symbolLabel || this.resolveSymbolLabel(id),
                    symbol: id
                  };
                });
              } else {
                let rowData = this.gotxGridComp.gotxGrid.getrowdata(data.rowIdx);
                rowData.purchaseValue = (parseFloat(data.quantity) * parseFloat(data.price)).toFixed(2);
                rowData.isEditing = false;
                this.gridData[data.rowIdx] = rowData;
                this.gotxGridComp.gotxGrid.updaterow(data.rowIdx, rowData);
              }
              // Update data property for grid binding
              this.data = [...this.gridData];
              // Reload grid if component is available
              if (this.gotxGridComp && this.gotxGridComp.gotxGrid) {
                setTimeout(() => {
                  this.gotxGridComp.reloadGrid(this.data);
                }, 100);
              }
              this.editingRowIndex = -1;
            }

            resolve(res);
          } else {
            const rawMsg = res['errMsg'] || 'Error occurred';
            const plainMsg = rawMsg.replace(/<[^>]*>/g, "");
            (document.getElementById('errMsgDiv') as HTMLElement).textContent = plainMsg;
            reject(res);
          }
        },
        async (httpError) => {
          var err = httpError['error'];
          if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
            if (err['ErrorElementPath'] == 'clientid') {
              this.cstmInvestorId.cmbInvestorId.setError(err['ErrorDescription']);
            }
          }
          document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');
          reject(httpError);
        }
      );
    });
  }

  async onFormLoad() {
    this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
    let inputMap = new Map();
    this.cstmInvestorId.cmbInvestorId.setValue(this.services.dataStore.getData("userID"));
    this.setDependencies();
    this.cstmProduct.setProductDropDown();
    this.reloadStock();

    // Call view action
    await this.callStockPnlApi('view');
  }

  resolveSymbolLabel(symbolCode: string): string {
    if (!symbolCode) return '';
    let stockMaster = this.services.dataStore.stockMaster;
    if (stockMaster && Array.isArray(stockMaster)) {
      // If symbolCode has colons like "NSE:ACC:NR", try to match exchSymbol
      let searchCode = symbolCode;
      if (searchCode.includes(':')) {
        let parts = searchCode.split(':');
        searchCode = parts[1] || parts[0];
      }

      let stock = stockMaster.find(s => s.exchSymbol.trim() === searchCode.trim());
      if (stock) {
        return stock.symbol; // This is the label (e.g., "ACC")
      }
    }
    // Fallback: split and return the middle part if it's "EXCH:SYMB:BOARD"
    if (symbolCode && symbolCode.includes(':')) {
      return symbolCode.split(':')[1];
    }
    return symbolCode;
  }

  resolveSymbolId(symbolLabel: string): string {
    if (!symbolLabel) return '';
    let stockMaster = this.services.dataStore.stockMaster;
    if (stockMaster && Array.isArray(stockMaster)) {
      let stock = stockMaster.find(s => s.symbol.trim() === symbolLabel.trim());
      if (stock) {
        return stock.exchSymbol; // This is the unique ID (e.g., "960000355")
      }
    }
    return symbolLabel;
  }

  restrictDecimal(event: any) {
    const key = event.key;
    
    // Allow control/navigation keys
    if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter', 'Home', 'End'].includes(key)) return true;
    
    // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if (event.ctrlKey && ['a', 'c', 'v', 'x'].includes(key.toLowerCase())) return true;
    
    // Block all special characters - only allow numeric digits (0-9)
    if (!/^[0-9]$/.test(key)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  restrictQtyInput(event: any) {
    let target = event.target as HTMLInputElement;
    let value = target.value;
    
    // Remove all non-numeric characters
    if (value && !/^\d*$/.test(value)) {
      value = value.replace(/[^\d]/g, '');
    }
    
    // Limit to 10 digits
    if (value && value.length > 10) {
      value = value.substring(0, 10);
    }
    
    target.value = value;
  }

  restrictTwoDecimals(event: any) {
    let target = event.target as HTMLInputElement;
    let value = target.value;
    
    // Only allow numeric input and one decimal point
    if (value && !/^\d*\.?\d*$/.test(value)) {
      // Remove invalid characters
      value = value.replace(/[^\d.]/g, '');
      // Remove multiple decimal points
      const parts = value.split('.');
      if (parts.length > 2) {
        value = parts[0] + '.' + parts.slice(1).join('');
      }
    }
    
    // Limit to 10 digits before decimal + 2 decimal places
    if (value.includes('.')) {
      const parts = value.split('.');
      // Limit integer part to 10 digits
      if (parts[0].length > 10) {
        parts[0] = parts[0].substring(0, 10);
      }
      // Limit decimal part to 2 digits
      if (parts[1] && parts[1].length > 2) {
        parts[1] = parts[1].substring(0, 2);
      }
      value = parts[0] + (parts[1] !== undefined ? '.' + parts[1] : '');
    } else {
      // Limit to 10 digits if no decimal point
      if (value.length > 10) {
        value = value.substring(0, 10);
      }
    }
    
    target.value = value;
  }

  truncateDecimals(value: any, digits: number): number | string {
    if (value === undefined || value === null || value === '') return '';
    let strVal = value.toString();
    if (strVal.includes('.')) {
      let parts = strVal.split('.');
      return parts[0] + '.' + parts[1].substring(0, digits);
    }
    return value;
  }

  handlePriceKeyDown(event: any) {
    const key = event.key;
    const target = event.target as HTMLInputElement;
    const value = target.value;
    const selectionStart = target.selectionStart;

    // Allow control/navigation keys
    if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter', 'Home', 'End'].includes(key)) return true;

    // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if (event.ctrlKey && ['a', 'c', 'v', 'x'].includes(key.toLowerCase())) return true;

    // Block non-numeric/dot keys
    if (!/^[0-9.]$/.test(key)) {
      event.preventDefault();
      return false;
    }

    // Block multiple dots
    if (key === '.' && value.includes('.')) {
      event.preventDefault();
      return false;
    }

    // Limit to 10 digits before decimal + 2 decimal places
    if (value.includes('.')) {
      const parts = value.split('.');
      const dotIndex = value.indexOf('.');
      
      // Limit integer part to 10 digits
      if (parts[0].length >= 10 && /^[0-9]$/.test(key)) {
        // Check if cursor is in the integer part (before decimal)
        if (selectionStart === null || selectionStart <= dotIndex) {
          // If NOT replacing a selection, block it
          if (selectionStart === null || target.selectionEnd === selectionStart) {
            event.preventDefault();
            return false;
          }
        }
      }
      
      // Block more than 2 decimal places
      if (parts[1] && parts[1].length >= 2) {
        // Check if cursor is after the decimal point
        if (selectionStart === null || selectionStart > dotIndex) {
          // If NOT replacing a selection, block it
          if (selectionStart === null || target.selectionEnd === selectionStart) {
            event.preventDefault();
            return false;
          }
        }
      }
    } else {
      // Limit to 10 digits if no decimal point
      if (value.length >= 10 && /^[0-9]$/.test(key)) {
        // If NOT replacing a selection, block it
        if (selectionStart === null || target.selectionEnd === selectionStart) {
          event.preventDefault();
          return false;
        }
      }
    }
    
    return true;
  }

  formatAvgPurchasePriceOnBlur(event: any) {
    // The blur event from app-text-box emits the value (string), not an event object
    let value: string = '';
    
    if (typeof event === 'string') {
      // Event is just the value string
      value = event;
    } else if (event && event.target) {
      // Event is a DOM event object
      value = (event.target as HTMLInputElement).value || '';
    } else if (event && event.value !== undefined) {
      // Event is an object with value property
      value = event.value || '';
    } else if (this.spnAvgPurchasePrice) {
      // Fallback: get value from component
      value = this.spnAvgPurchasePrice.getFieldValue() || '';
    }
    
    if (value && value.trim() !== '') {
      // Remove any non-numeric characters except decimal point
      value = value.replace(/[^\d.]/g, '');
      
      // Ensure only one decimal point
      const parts = value.split('.');
      if (parts.length > 2) {
        value = parts[0] + '.' + parts.slice(1).join('');
      }
      
      // Format to exactly 2 decimals
      if (value.includes('.')) {
        const decimalParts = value.split('.');
        const integerPart = decimalParts[0] || '0';
        const decimalPart = (decimalParts[1] || '').substring(0, 2).padEnd(2, '0');
        value = integerPart + '.' + decimalPart;
      } else if (value) {
        // If no decimal point, add .00
        value = value + '.00';
      }
      
      // Update the component value
      if (this.spnAvgPurchasePrice) {
        this.spnAvgPurchasePrice.setValue(value);
      }
      
      // Update DOM input if event has target
      if (event && event.target) {
        (event.target as HTMLInputElement).value = value;
      }
      
      // Call the generic blur handler with the formatted value
      this.genericOnBlur('spnAvgPurchasePrice', value);
    } else {
      // If value is empty, just call generic blur without formatting
      // This will handle validation properly
      this.genericOnBlur('spnAvgPurchasePrice', '');
    }
  }

  handleQtyKeyDown(event: any) {
    const key = event.key;
    const target = event.target as HTMLInputElement;
    const value = target.value;
    
    // Allow control/navigation keys
    if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter', 'Home', 'End'].includes(key)) return true;
    
    // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if (event.ctrlKey && ['a', 'c', 'v', 'x'].includes(key.toLowerCase())) return true;
    
    // Block all special characters including '-' and '+' - only allow numeric digits (0-9)
    if (!/^[0-9]$/.test(key)) {
      event.preventDefault();
      return false;
    }
    
    // Limit to 10 digits
    if (value && value.length >= 10) {
      // Allow if replacing selected text
      if (target.selectionStart !== target.selectionEnd) {
        return true;
      }
      event.preventDefault();
      return false;
    }
    
    return true;
  }

  formatNumberWithCommas(value: any): string {
    if (value === undefined || value === null || value === '') return '';
    
    let strVal = value.toString();
    
    // Handle negative sign
    let isNegative = false;
    if (strVal.startsWith('-')) {
      isNegative = true;
      strVal = strVal.substring(1);
    }
    
    // Split integer and decimal parts
    let parts = strVal.split('.');
    let integerPart = parts[0] || '0';
    let decimalPart = parts[1] || '';
    
    // Add commas to integer part
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    
    // Combine parts
    let result = isNegative ? '-' + integerPart : integerPart;
    if (decimalPart) {
      result += '.' + decimalPart;
    }
    
    return result;
  }

  async cstmExchange_exchSelected(event) {
    this.cstmProduct.updateProductList(this.cstmExchange.cmbExchange.getFieldValue());
    this.reloadStock();
  }

  async cstmProduct_productSelected(event) {
    this.reloadStock();
  }

  async cmbStock_stockSelected(event) {
    this.selectedStock = event;
  }

  setInputs(param: any) {
    let params = this.services.http.mapToJson(param);
    if (params['mode']) {
      this.mode = params['mode'];
    }
  }

  async submitForm(path, apiCode, serviceCode) {
    this.submitData['formName'] = 'pnlCalculator';
    await super.submit(path, apiCode, serviceCode);
  }

  getFieldInfo() {
    this.additionalInfo['cstmInvestorId_desc'] = this.cstmInvestorId.getFieldInfo();
    return this.additionalInfo;
  }

  getFieldValue() {
    this.value.cstmInvestorId = this.cstmInvestorId.getFieldValue();
    return this.value;
  }

  setValue(inputValue, inputDesc = undefined) {
    this.setBasicFieldsValue(inputValue, inputDesc);
    this.cstmInvestorId.setValue(inputValue['cstmInvestorId'], inputDesc['cstmInvestorId_desc']);
    this.value = new pnlCalculatorModel();
    this.value.setValue(inputValue);
    this.setDependencies();
    this.passNewValue(this.value);
  }

  ngOnInit() {
    if (this.formCode == undefined) { this.formCode = 'pnlCalculator'; }
    if (this.formOnLoadError) { return; }
    setTimeout(() => {
      this.skeletonContentLoaded = true;
    }, 1000);
    var styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = customCss;
    styleElement.id = 'pnlCalculator_customCss';
    document.getElementsByTagName('head')[0].appendChild(styleElement);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    var styleElement = document.getElementById('pnlCalculator_customCss');
    if (styleElement) {
      styleElement.parentNode.removeChild(styleElement);
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.subsBFldsValueUpdates();
      this.value.cstmInvestorId = this.cstmInvestorId.getFieldValue();
      this.cstmInvestorId.valueChangeUpdates().subscribe((value) => { this.value.cstmInvestorId = value; });
      this.value.cstmExchange = this.cstmExchange.getFieldValue();
      this.cstmExchange.valueChangeUpdates().subscribe((value) => { this.value.cstmExchange = value; });
      this.value.cstmProduct = this.cstmProduct.getFieldValue();
      this.cstmProduct.valueChangeUpdates().subscribe((value) => { this.value.cstmProduct = value; });
      this.onFormLoad();
      this.checkForHTabOverFlow();
      (window as any).pnlCalculatorComponent = this;
    });
  }

  clearError() {
    super.clearBasicFieldsError();
    super.clearHTabErrors();
    super.clearVTabErrors();
    this.cstmInvestorId.clearError();
    this.errors = 0;
    this.errorMessage = [];
  }

  onReset() {
    super.resetBasicFields();
    this.cstmInvestorId.onReset();
    this.clearHTabErrors();
    this.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
    this.additionalInfo = undefined;
    this.dependencyMap.clear();
    this.value = new pnlCalculatorModel();
    this.passNewValue(this.value);
    this.setReadOnly(false);
    this.gridData = [];
    this.editingRowIndex = -1;
    this.onFormLoad();
  }

  reloadStock() {
    if (this.cstmExchange != undefined) {
      let exch = this.cstmExchange.cmbExchange.getFieldValue();
      let pdct = this.cstmProduct.cmbProduct.getFieldValue();
      if (typeof pdct == 'object') {
        pdct = pdct.text
      }
      this.cmbStock.gotxInput.val("");
      // Use "AL" (All) board to get all stocks, similar to Order Book when board is set to "AL"
      let board = "AL";
      this.cmbStock.source = this.services.dataStore.getcmbStockInput(this.cmbStock.searchMode, exch, pdct, board);
    }
  }

  refreshStatusMsg: string = '';

  async btnRefresh_click(event) {
    this.reloadStock();
    //this.cmbStock.gotxInput.val("");
    //this.spnPurchaseQty.setValue("");
    //this.spnAvgPurchasePrice.setValue("");
    this.gridData = [];
    this.editingRowIndex = -1;
    this.showRefreshStatus = true;

    const now = new Date();
    const timeString = now.toTimeString().split(' ')[0]; // Gets HH:MM:SS
    this.refreshStatusMsg = '(Refreshed As Of ' + timeString + ')';

    this.callStockPnlApi('view');
  }

  async btnAddSymbol_click(event) {
    document.getElementById('errMsgDiv').innerHTML = "";

    let stockValue = this.cmbStock.gotxInput.val();
    let quantityValue = this.spnPurchaseQty.getFieldValue();
    let priceValue = this.spnAvgPurchasePrice.getFieldValue();

    if (!stockValue || !quantityValue || !priceValue) {
      document.getElementById('errMsgDiv').innerHTML = "All fields Required";
      return;
    }

    console.log("stockValue>>>>>>>", stockValue);
    let stockSymbol = '';
    if (stockValue && typeof stockValue === 'object' && stockValue.value) {
      stockSymbol = stockValue.value;
    } else if (stockValue) {
      let typedText = (typeof stockValue === 'object') ? stockValue.label : stockValue.toString();
      // Try to find the matching symbol in the source list
      let match = this.cmbStock.source.find(el =>
        (el.exchSymbol && el.exchSymbol.toString().toLowerCase() === typedText.toLowerCase()) ||
        (el.symbol && el.symbol.toString().toLowerCase() === typedText.toLowerCase())
      );

      if (match) {
        stockSymbol = match.exchSymbol;
      } else {
        stockSymbol = typedText;
      }
    }

    console.log("stockSymbol>>>>>>>", stockSymbol);
    if (this.gridData.find(el => el.symbol == stockSymbol)) {
      document.getElementById('errMsgDiv').innerHTML = "Symbol already added";
      return;
    }

    // Verify if the resolved symbol exists in the source
    if (!this.cmbStock.source.find(el => (el.exchSymbol || el.symbol) == stockSymbol)) {
      document.getElementById('errMsgDiv').innerHTML = "Invalid Symbol Id";
      return;
    }
    // Call Insert API
    await this.callStockPnlApi('insert', {
      stockSymbol: stockSymbol,
      quantity: parseInt(quantityValue, 10),
      price: priceValue
    });
  }

  btnEdit_Click(rowIdx) {
    let rowData = this.gotxGridComp.gotxGrid.getrowdata(rowIdx);
    // Prevent editing totals row
    if (rowData && rowData.symbol === 'TOTAL_ROW') {
      return;
    }
    if (this.editingRowIndex >= 0 && this.editingRowIndex !== rowIdx) {
      this.cancelEdit(this.editingRowIndex);
    }
    this.editingRowIndex = rowIdx;
    rowData.isEditing = true;
    this.gotxGridComp.gotxGrid.updaterow(rowIdx, rowData);
  }

  async btnDelete_Click(rowIdx) {
    let rowData = this.gotxGridComp.gotxGrid.getrowdata(rowIdx);
    // Prevent deleting totals row
    if (rowData && rowData.symbol === 'TOTAL_ROW') {
      return;
    }
    await this.callStockPnlApi('delete', {
      stockSymbol: rowData.symbol, // Assuming identification by symbol
      // Pass other identifiers if needed? The requirement just says "clicking delete icon it should be delete"
      // I'll pass stockCode as symbol.
      rowIdx: rowIdx
    });
  }

  async btnOK_Click(rowIdx) {
    // Get values directly from input fields instead of rowData
    let qtyInput = document.querySelector(`input[data-row="${rowIdx}"][data-field="qty"]`) as HTMLInputElement;
    let priceInput = document.querySelector(`input[data-row="${rowIdx}"][data-field="avgPrice"]`) as HTMLInputElement;
    
    if (!qtyInput || !priceInput) {
      document.getElementById('errMsgDiv').innerHTML = "Unable to read input values";
      return;
    }
    
    let purchaseQty = parseInt(qtyInput.value, 10);
    let avgPurchasePrice = parseFloat(priceInput.value);

    if (isNaN(purchaseQty) || isNaN(avgPurchasePrice) || purchaseQty <= 0 || avgPurchasePrice <= 0) {
      document.getElementById('errMsgDiv').innerHTML = "Invalid values for Purchase Qty or Avg Purchase Price";
      return;
    }

    // Update row data with new values
    let rowData = this.gotxGridComp.gotxGrid.getrowdata(rowIdx);
    rowData.qty = purchaseQty;
    rowData.avgPrice = avgPurchasePrice;
    
    // Calculate Purchase Value
    let purchaseValue = purchaseQty * avgPurchasePrice;
    rowData.purchaseValue = purchaseValue.toFixed(2);
    
    // Get LTP value (should already be in rowData from API)
    let ltp = parseFloat(rowData.ltp || 0);
    
    // Calculate LTP Total Value = qty * ltp
    let ltpTotalValue = purchaseQty * ltp;
    rowData.ltpTotalValue = ltpTotalValue.toFixed(2);
    
    // Calculate Profit/Loss = LTP Total Value - Purchase Value
    let profitLoss = ltpTotalValue - purchaseValue;
    rowData.profitLoss = profitLoss.toFixed(2);
    
    // Update the row in grid
    rowData.isEditing = false;
    this.gotxGridComp.gotxGrid.updaterow(rowIdx, rowData);
    
    // Update gridData array
    this.gridData[rowIdx] = rowData;
    
    // Recalculate totals
    this.addTotalsRowToGrid();
    this.data = [...this.gridData];
    
    // Reload grid to show updated totals
    if (this.gotxGridComp && this.gotxGridComp.gotxGrid) {
      setTimeout(() => {
        this.gotxGridComp.reloadGrid(this.data);
      }, 100);
    }

    // Call Update API
    await this.callStockPnlApi('update', {
      stockSymbol: rowData.symbol,
      quantity: purchaseQty,
      price: avgPurchasePrice,
      rowIdx: rowIdx
    });
  }

  cancelEdit(rowIdx) {
    let rowData = this.gotxGridComp.gotxGrid.getrowdata(rowIdx);
    rowData.isEditing = false;
    this.gotxGridComp.gotxGrid.updaterow(rowIdx, rowData);
  }

  transalte(text) {
    return this.services.translate.instant(text);
  }


  fieldDependencies = {
  }

  datafields = [
    { name: 'symbol', type: 'string' },
    { name: 'symbolLabel', type: 'string' },
    { name: 'qty', type: 'number' },
    { name: 'avgPrice', type: 'number' },
    { name: 'purchaseValue', type: 'number' },
    { name: 'ltp', type: 'number' },
    { name: 'ltpTotalValue', type: 'number' },
    { name: 'profitLoss', type: 'number' },
    { name: 'isEditing', type: 'boolean' }
  ];

  rowId = "symbol";
  datatype = "json";

  columns: any[] = [
    {
      text: this.transalte('PNLCalculatorGrid.StockCode'),
      datafield: 'symbolLabel',
      width: 200,
      cellsalign: 'left',
      align: 'center',
      cellsrenderer: (row, column, value, defaultHtml, columnProperties, rowData) => {
        // Check if this is the totals row - match Stock Holding screen styling
        if (rowData && rowData.symbol === 'TOTAL_ROW') {
          return '<div style="width: 100%; height: 100%; display: flex; align-items: center; padding-left: 5px; font-weight: bold; background-color: #d2d2d2; color: #000;">Total</div>';
        }
        return '<div style="margin-top: 5px; margin-left: 5px;">' + (value || (rowData ? rowData.symbol : '')) + '</div>';
      }
    },
    {
      text: this.transalte('PNLCalculatorGrid.PurchaseQty'),
      datafield: 'qty',
      width: 150,
      cellsalign: 'center',
      align: 'center',
      cellsrenderer: (row, column, value, defaultHtml, columnProperties, rowData) => {
        // Check if this is the totals row - match Stock Holding screen styling
        if (rowData && rowData.symbol === 'TOTAL_ROW') {
          return '<div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; font-weight: bold; background-color: #d2d2d2; color: #000;"></div>';
        }
        if (rowData && rowData.isEditing) {
          return '<input type="text" class="form-control pnl-edit-input" value="' + (value ? parseInt(value, 10) : '') + '" data-row="' + row + '" data-field="qty" style="width:100%;text-align:center;" maxlength="10" onkeydown="return window.pnlCalculatorComponent.restrictDecimal(event)" oninput="window.pnlCalculatorComponent.restrictQtyInput(event);" />';
        }
        return '<div style="text-align:center;">' + (value ? parseInt(value, 10) : '') + '</div>';
      }
    },
    {
      text: this.transalte('PNLCalculatorGrid.AvgPurchasePrice'),
      datafield: 'avgPrice',
      width: 180,
      cellsalign: 'center',
      align: 'center',
      cellsrenderer: (row, column, value, defaultHtml, columnProperties, rowData) => {
        // Check if this is the totals row - match Stock Holding screen styling
        if (rowData && rowData.symbol === 'TOTAL_ROW') {
          return '<div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; font-weight: bold; background-color: #d2d2d2; color: #000;"></div>';
        }
        if (rowData && rowData.isEditing) {
          return '<input type="text" class="form-control pnl-edit-input" value="' + (value || '') + '" data-row="' + row + '" data-field="avgPrice" style="width:100%;text-align:center;" maxlength="13" onkeydown="return window.pnlCalculatorComponent.handlePriceKeyDown(event)" oninput="window.pnlCalculatorComponent.restrictTwoDecimals(event);" />';
        }
        return '<div style="text-align:center;">' + this.truncateDecimals(value, 2) + '</div>';
      }
    },
    {
      text: this.transalte('PNLCalculatorGrid.PurchaseValue'),
      datafield: 'purchaseValue',
      width: 200,
      cellsalign: 'center',
      align: 'center',
      cellsrenderer: (row, column, value, defaultHtml, columnProperties, rowData) => {
        // Check if this is the totals row - match Stock Holding screen styling
        if (rowData && rowData.symbol === 'TOTAL_ROW') {
          let formattedValue = this.formatNumberWithCommas(value || '0.00');
          return '<div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; font-weight: bold; background-color: #d2d2d2; color: #000;">' + formattedValue + '</div>';
        }
        let formattedValue = this.formatNumberWithCommas(this.truncateDecimals(value, 2));
        return '<div style="text-align:center;">' + formattedValue + '</div>';
      }
    },
    {
      text: this.transalte('PNLCalculatorGrid.LTP'),
      datafield: 'ltp',
      width: 100,
      cellsalign: 'center',
      align: 'center',
      cellsrenderer: (row, column, value, defaultHtml, columnProperties, rowData) => {
        // Check if this is the totals row - match Stock Holding screen styling
        if (rowData && rowData.symbol === 'TOTAL_ROW') {
          return '<div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; font-weight: bold; background-color: #d2d2d2; color: #000;"></div>';
        }
        return '<div style="text-align:center;">' + this.truncateDecimals(value, 2) + '</div>';
      }
    },
    {
      text: this.transalte('PNLCalculatorGrid.LTPTotalValue'),
      datafield: 'ltpTotalValue',
      width: 150,
      cellsalign: 'center',
      align: 'center',
      cellsrenderer: (row, column, value, defaultHtml, columnProperties, rowData) => {
        // Check if this is the totals row - match Stock Holding screen styling
        if (rowData && rowData.symbol === 'TOTAL_ROW') {
          let formattedValue = this.formatNumberWithCommas(value || '0.00');
          return '<div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; font-weight: bold; background-color: #d2d2d2; color: #000;">' + formattedValue + '</div>';
        }
        if (value === undefined || value === null || value === '') return '<div style="text-align:center;"></div>';
        let numValue = parseFloat(value);
        if (isNaN(numValue)) return '<div style="text-align:center;">' + value + '</div>';
        let formattedValue = this.formatNumberWithCommas(numValue.toFixed(2));
        return '<div style="text-align:center;">' + formattedValue + '</div>';
      }
    },
    {
      text: this.transalte('PNLCalculatorGrid.ProfitLoss'),
      datafield: 'profitLoss',
      width: 200,
      cellsalign: 'center',
      align: 'center',
      cellsrenderer: (row, column, value, defaultHtml, columnProperties, rowData) => {
        // Check if this is the totals row - match Stock Holding screen styling
        if (rowData && rowData.symbol === 'TOTAL_ROW') {
          let formattedValue = this.formatNumberWithCommas(value || '0.00');
          return '<div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; font-weight: bold; background-color: #d2d2d2; color: #000;">' + formattedValue + '</div>';
        }
        let color = (parseFloat(value) >= 0) ? 'green' : 'red';
        let formattedValue = this.formatNumberWithCommas(this.truncateDecimals(value, 2));
        return '<div style="text-align:center; color:' + color + '; font-weight: 800;">' + formattedValue + '</div>';
      }
    },
    {
      text: this.transalte('PNLCalculatorGrid.Edit'),
      width: 60,
      cellsrenderer: (row, column, value, defaultHtml, columnProperties, rowData) => {
        // Check if this is the totals row - match Stock Holding screen styling
        if (rowData && rowData.symbol === 'TOTAL_ROW') {
          return '<div style="background-color: #d2d2d2; width: 100%; height: 100%;"></div>';
        }
        if (rowData && rowData.isEditing) {
          return '<button class="btn btn-xs btn-success" style="width:100%;" onclick="window.pnlCalculatorComponent.btnOK_Click(' + row + ')"><i class="fa fa-check"></i></button>';
        }
        return '<button class="btn btn-xs btn-primary" style="width:100%;" title="Edit" onclick="window.pnlCalculatorComponent.btnEdit_Click(' + row + ')"><i class="fa fa-columns"></i></button>';
      }
    },
    {
      text: this.transalte('PNLCalculatorGrid.Delete'),
      width: 60,
      cellsrenderer: (row, column, value, defaultHtml, columnProperties, rowData) => {
        // Check if this is the totals row - match Stock Holding screen styling
        if (rowData && rowData.symbol === 'TOTAL_ROW') {
          return '<div style="background-color: #d2d2d2; width: 100%; height: 100%;"></div>';
        }
        if (rowData && rowData.isEditing) {
          return '';
        }
        return '<button class="btn btn-xs btn-danger" style="width:100%;" title="Delete" onclick="window.pnlCalculatorComponent.btnDelete_Click(' + row + ')"><i class="fa fa-trash"></i></button>';
      }
    }
  ];

  updateRowField(rowIdx: number, field: string, value: any) {
    let rowData = this.gotxGridComp.gotxGrid.getrowdata(rowIdx);
    if (rowData) {
      // Prevent editing totals row
      if (rowData.symbol === 'TOTAL_ROW') {
        return;
      }
      
      let parsedValue = (field === 'qty') ? (parseInt(value, 10) || 0) : (this.truncateDecimals(value, 2) || 0);
      rowData[field] = parsedValue;
      
      // Recalculate purchaseValue if qty or avgPrice changes
      if (field === 'qty' || field === 'avgPrice') {
        let qty = parseFloat(rowData.qty || 0);
        let price = parseFloat(rowData.avgPrice || 0);
        rowData.purchaseValue = (qty * price).toFixed(2);
      }
      
      this.gridData[rowIdx] = rowData;
      // Recalculate totals after updating
      this.addTotalsRowToGrid();
      // Update data property for grid binding
      this.data = [...this.gridData];
      // Fast update without full row re-render
      this.gotxGridComp.gotxGrid.setcellvalue(rowIdx, field, parsedValue);
      // Reload grid to update totals row
      setTimeout(() => {
        if (this.gotxGridComp && this.gotxGridComp.gotxGrid) {
          this.gotxGridComp.reloadGrid(this.data);
        }
      }, 50);
    }
  }

  data = [];
}
